var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"100vh"}},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-3x"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }